<template>
    <div v-if="layer.itemType == 'container_element'" class="editor-element box-element" :style="{
        height: layer.height,
        width: layer.width,
        backgroundColor: layer.backgroundColor,
        display: layer.display,
        flexDirection: layer.flexDirection,
        justifyContent: layer.justifyContent,
        alignItems: layer.alignItems,
        flexWrap: layer.flexWrap,
        gap: layer.gap,
        position: layer.position,
        left: layer.left,
        top: layer.top,
        right: layer.right,
        bottom: layer.bottom,
        paddingTop: layer.paddingTop,
        paddingRight: layer.paddingRight,
        paddingBottom: layer.paddingBottom,
        paddingLeft: layer.paddingLeft,
        marginTop: layer.marginTop,
        marginRight: layer.marginRight,
        marginBottom: layer.marginBottom,
        marginLeft: layer.marginLeft,
        borderTop: `${layer.borderTopSize} ${layer.borderType} ${layer.borderTopColor}`,
        borderBottom: `${layer.borderBottomSize} ${layer.borderType} ${layer.borderBottomColor}`,
        borderLeft: `${layer.borderLeftSize} ${layer.borderType} ${layer.borderLeftColor}`,
        borderRight: `${layer.borderRightSize} ${layer.borderType} ${layer.borderRightColor}`,
        borderTopLeftRadius: layer.borderTopLeftRadius,
        borderTopRightRadius: layer.borderTopRightRadius,
        borderBottomLeftRadius: layer.borderBottomLeftRadius,
        borderBottomRightRadius: layer.borderBottomRightRadius,
    }" @click.self="selectElement()" :id="isGuostItem ? layer.itemId + '_guost_' + GuostItemIndex : layer.itemId"
        :class="{ activateGuost: isGuostItem }" :layer-index="itemLayerIndex" :layer-type="layer.itemType"
        :layer-level="itemLayerLever" :layer-parent-type="itemParentLayerType" :layer-parent-index="itemParentLayerIndex"
        :layer-index-path="JSON.stringify(newItemLayerIndexPath)">
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-left-edge">
        </div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-right-edge">
        </div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-top-edge"></div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-bottom-edge">
        </div>

        <EditorElementTools
            v-if="layer.itemSelected && !isGuostItem && !readonly && !isParentGuostItem && itemParentLayerType != 'page_element'"
            :element="layer" @deleteNode="onDeleteNode" @dublicateNode="dublicateNode" @close="layer.itemSelected = false"
            @pastNode="onPastNode" @saveNode="saveNodeComponent">
        </EditorElementTools>

        <template v-for="(child, index) in layer.children">
            <template v-if="child.itemType == 'container_element' && child.dataOrigin != '' && !isApplyingProfile">
                <EditorTemplateElementViewer v-for="(n, j) in child.numberOfItems" :key="'goust_' + j + n" :layer="child"
                    @selectElement="() => {
                        child.itemSelected = true;
                    }" :itemLayerIndex="index" :itemLayerLever="itemLayerLever + 1" :isGuostItem="j > 0"
                    :GuostItemIndex="j" :parentDataIndex="GuostItemIndex" :isParentGuostItem="isGuostItem"
                    :itemParentLayerType="layer.itemType" :itemLayerIndexPath="[...newItemLayerIndexPath]"
                    :readonly="readonly" @deleteElement="onDeleteElement(index)"
                    @dublicateElement="onDublicateElement($event, layer.children, index)"
                    @pastElement="onPastElement($event, layer.children, index)">

                </EditorTemplateElementViewer>
            </template>
            <EditorTemplateElementViewer v-else :key="index" :layer="child" @selectElement="() => {
                child.itemSelected = true;
            }" :itemLayerIndex="index" :itemLayerLever="itemLayerLever + 1" :itemParentLayerType="layer.itemType"
                :itemLayerIndexPath="[...newItemLayerIndexPath]" :isGuostItem="isGuostItem"
                :isParentGuostItem="isParentGuostItem" :GuostItemIndex="GuostItemIndex" :parentDataIndex="parentDataIndex"
                :readonly="readonly" @deleteElement="onDeleteElement(index)"
                @dublicateElement="onDublicateElement($event, layer.children, index)"
                @pastElement="onPastElement($event, layer.children, index)"
                @onTextChange="updateChangedText($event, layer.children, index)" :isApplyingProfile="isApplyingProfile">
            </EditorTemplateElementViewer>
        </template>
    </div>
    <div v-else-if="layer.itemType == 'line_element'" class="editor-element line-element" :style="{
        height: layer.height,
        width: layer.width,
        backgroundColor: layer.backgroundColor,
        position: layer.position,
        left: layer.left,
        top: layer.top,
        right: layer.right,
        bottom: layer.bottom,
        marginTop: layer.marginTop,
        marginRight: layer.marginRight,
        marginBottom: layer.marginBottom,
        marginLeft: layer.marginLeft,
    }" @click.self="selectElement()" :id="isGuostItem ? layer.itemId + '_guost_' + GuostItemIndex : layer.itemId"
        :class="{ activateGuost: isGuostItem }" :layer-index="itemLayerIndex" :layer-type="layer.itemType"
        :layer-level="itemLayerLever" :layer-parent-type="itemParentLayerType" :layer-parent-index="itemParentLayerIndex"
        :layer-index-path="JSON.stringify(newItemLayerIndexPath)">
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-left-edge">
        </div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-right-edge">
        </div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-top-edge"></div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-bottom-edge">
        </div>

        <EditorElementTools v-if="layer.itemSelected && !isGuostItem && !readonly && !isParentGuostItem" :element="layer"
            @deleteNode="onDeleteNode" @dublicateNode="dublicateNode" @close="layer.itemSelected = false"
            @pastNode="onPastNode" @saveNode="saveNodeComponent">
        </EditorElementTools>
    </div>
    <div v-else-if="layer.itemType == 'star_element'" class="editor-element star-element"
        style="display: flex; align-items: center;" :style="{
            height: layer.height,
            width: layer.width,
            position: layer.position,
            left: layer.left,
            top: layer.top,
            right: layer.right,
            bottom: layer.bottom,
            marginTop: layer.marginTop,
            marginRight: layer.marginRight,
            marginBottom: layer.marginBottom,
            marginLeft: layer.marginLeft,
        }" @click="selectElement()" :id="isGuostItem ? layer.itemId + '_guost_' + GuostItemIndex : layer.itemId"
        :class="{ activateGuost: isGuostItem }" :layer-index="itemLayerIndex" :layer-type="layer.itemType"
        :layer-level="itemLayerLever" :layer-parent-type="itemParentLayerType" :layer-parent-index="itemParentLayerIndex"
        :layer-index-path="JSON.stringify(newItemLayerIndexPath)">
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-left-edge">
        </div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-right-edge">
        </div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-top-edge"></div>
        <div v-if="layer.showBoxEdjes && !readonly"
            :class="{ 'active': layer.itemSelected && !isGuostItem, onMainBox: !isGuostItem }" class="box-bottom-edge">
        </div>

        <EditorElementTools v-if="layer.itemSelected && !isGuostItem && !readonly && !isParentGuostItem" :element="layer"
            @deleteNode="onDeleteNode" @dublicateNode="dublicateNode" @close="layer.itemSelected = false"
            @pastNode="onPastNode" @saveNode="saveNodeComponent">
        </EditorElementTools>

        <div class="stars-widget" style="display: flex; align-items: center; width: 100%;">
            <template v-for="(n, index) in 5">
                <svg v-if="n <= layer.numberOfItems" :key="index" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_20_32)">
                        <path
                            d="M12 17L6.12199 20.59L7.71999 13.89L2.48999 9.41L9.35499 8.86L12 2.5L14.645 8.86L21.511 9.41L16.28 13.89L17.878 20.59L12 17Z"
                            :fill="layer.backgroundColor" />
                    </g>
                    <defs>
                        <clipPath id="clip0_20_32">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <svg v-else :key="index" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_20_32)">
                        <path
                            d="M12 17L6.12199 20.59L7.71999 13.89L2.48999 9.41L9.35499 8.86L12 2.5L14.645 8.86L21.511 9.41L16.28 13.89L17.878 20.59L12 17Z"
                            :stroke="layer.backgroundColor" />
                    </g>
                    <defs>
                        <clipPath id="clip0_20_32">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </template>

        </div>

    </div>
    <div v-else-if="layer.itemType == 'text_element'" class="editor-element text-element" style="max-width:100%" :style="{
        width: 'auto',
        height: 'auto',
        display: 'flex',
        backgroundColor: layer.backgroundColor,
        position: layer.position,
        left: layer.left,
        top: layer.top,
        right: layer.right,
        bottom: layer.bottom,
        paddingTop: layer.paddingTop,
        paddingRight: layer.paddingRight,
        paddingBottom: layer.paddingBottom,
        paddingLeft: layer.paddingLeft,
        marginTop: layer.marginTop,
        marginRight: layer.marginRight,
        marginBottom: layer.marginBottom,
        marginLeft: layer.marginLeft,
        borderTop: `${layer.borderTopSize} ${layer.borderType} ${layer.borderTopColor}`,
        borderBottom: `${layer.borderBottomSize} ${layer.borderType} ${layer.borderBottomColor}`,
        borderLeft: `${layer.borderLeftSize} ${layer.borderType} ${layer.borderLeftColor}`,
        borderRight: `${layer.borderRightSize} ${layer.borderType} ${layer.borderRightColor}`,
        borderTopLeftRadius: layer.borderTopLeftRadius,
        borderTopRightRadius: layer.borderTopRightRadius,
        borderBottomLeftRadius: layer.borderBottomLeftRadius,
        borderBottomRightRadius: layer.borderBottomRightRadius,
    }" @click="selectElement()" :class="{ 'active': layer.itemSelected }" :id="layer.itemId"
        :layer-index="itemLayerIndex" :layer-type="layer.itemType" :layer-level="itemLayerLever"
        :layer-parent-type="itemParentLayerType" :layer-parent-index="itemParentLayerIndex"
        :layer-index-path="JSON.stringify(newItemLayerIndexPath)">
        <div v-if="!readonly" class="text-left-edge"></div>
        <div v-if="!readonly" class="text-right-edge"></div>
        <div v-if="!readonly" class="text-top-edge"></div>
        <div v-if="!readonly" class="text-bottom-edge"></div>
        <EditorElementTools v-if="layer.itemSelected && !isGuostItem && !readonly && !isParentGuostItem" :element="layer"
            @deleteNode="onDeleteNode" @dublicateNode="dublicateNode" @close="layer.itemSelected = false"
            @pastNode="onPastNode">
        </EditorElementTools>
        <div v-if="layer.showTextWarning && !$store.state.isDownloadingCV" class="text-fit-warning"></div>
        <div class="text-container" :style="{
            width: '100%',
            height: '100%',
            color: layer.textColor,
            fontFamily: layer.fontFamily,
            fontSize: layer.fontSize,
            fontWeight: layer.fontWeight,
            fontStyle: layer.fontStyle,
            textAlign: layer.textAlign,
            lineHeight: layer.textLineSpacing,
            textDecoration: layer.textDecoration,
            textTransform: layer.textCase,
        }" data-text="yes" :class="{ activateEllipsis: layer.heightSizeType == 'default' }" data-is-text="true">
            <span class="text-editable-container" v-html="textContent"
                :contenteditable="layer.itemSelected && !isGuostItem && !readonly" v-once @input="onTextChange">
            </span>
        </div>
    </div>
    <div v-else-if="layer.itemType == 'image_element'" class="editor-element image-element" :style="{
        position: layer.position,
        left: layer.left,
        top: layer.top,
        right: layer.right,
        bottom: layer.bottom,
        backgroundColor: layer.backgroundColor,
        paddingTop: layer.paddingTop,
        paddingRight: layer.paddingRight,
        paddingBottom: layer.paddingBottom,
        paddingLeft: layer.paddingLeft,
        marginTop: layer.marginTop,
        marginRight: layer.marginRight,
        marginBottom: layer.marginBottom,
        marginLeft: layer.marginLeft,
    }" :class="{ 'active': layer.itemSelected }" @click="selectElement()" :id="layer.itemId"
        :layer-index="itemLayerIndex" :layer-type="layer.itemType" :layer-level="itemLayerLever"
        :layer-parent-type="itemParentLayerType" :layer-parent-index="itemParentLayerIndex"
        :layer-index-path="JSON.stringify(newItemLayerIndexPath)">
        <div v-if="!readonly" class="image-left-edge"></div>
        <div v-if="!readonly" class="image-right-edge"></div>
        <div v-if="!readonly" class="image-top-edge"></div>
        <div v-if="!readonly" class="image-bottom-edge"></div>
        <EditorElementTools v-if="layer.itemSelected && !isGuostItem && !readonly" :element="layer"
            @deleteNode="onDeleteNode" @dublicateNode="dublicateNode" @close="layer.itemSelected = false"
            @pastNode="onPastNode">
        </EditorElementTools>
        <img :src="imageSrc" :style="{
            height: layer.height,
            width: layer.width,
            borderTop: `${layer.borderTopSize} ${layer.borderType} ${layer.borderTopColor}`,
            borderBottom: `${layer.borderBottomSize} ${layer.borderType} ${layer.borderBottomColor}`,
            borderLeft: `${layer.borderLeftSize} ${layer.borderType} ${layer.borderLeftColor}`,
            borderRight: `${layer.borderRightSize} ${layer.borderType} ${layer.borderRightColor}`,
            borderTopLeftRadius: layer.borderTopLeftRadius,
            borderTopRightRadius: layer.borderTopRightRadius,
            borderBottomLeftRadius: layer.borderBottomLeftRadius,
            borderBottomRightRadius: layer.borderBottomRightRadius,
            'object-fit': layer.imageFit
        }">
    </div>
</template>
<script>
import { eventBus } from "@/main";
import EditorElementTools from "./editor_element_tools.vue"
export default {
    name: "editor-template-element-viewer",
    components: {
        EditorTemplateElementViewer: () => import('./editor_template_element_viewer.vue'),
        EditorElementTools
    },
    props: {
        layer: {
            type: Object,
            default: () => {
                return {
                    itemName: "Layer 1",
                    children: []
                };
            }
        },
        itemLayerIndex: {
            type: Number,
            default: 0
        },
        itemLayerLever: {
            type: Number,
            default: 0
        },
        itemParentLayerIndex: {
            type: Number,
            default: 0
        },
        itemParentLayerType: {
            type: String,
            default: ""
        },
        itemLayerIndexPath: {
            type: Array,
            default: () => []
        },
        isGuostItem: {
            type: Boolean,
            default: false
        },
        isParentGuostItem: {
            type: Boolean,
            default: false
        },
        GuostItemIndex: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean,
            default: false
        },
        parentDataIndex: {
            type: Number,
            default: 0
        },
        isApplyingProfile: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {

        };
    },
    watch: {
    },
    computed: {
        newItemLayerIndexPath() {
            let vm = this;
            let indexPath = [...vm.itemLayerIndexPath];
            indexPath.push(vm.itemLayerIndex);
            return indexPath;
        },
        textContent() {
            let vm = this;
            return vm.layer.textValue
        },
        imageSrc() {
            let vm = this;
            return vm.layer.imageSrc;
        }
    },
    mounted() {

    },
    methods: {
        saveNodeComponent() {
            let vm = this;
            eventBus.$emit("onSaveNodeComponent", vm.layer);
        },
        onTextChange(e) {
            let vm = this;
            vm.$emit("onTextChange", e.target.innerText);
        },
        updateChangedText(textValue, children, index) {
            children[index].textValue = textValue;
        },
        selectElement() {
            let vm = this;
            if (!vm.readonly) {
                eventBus.$emit("onElementSelected", vm.layer);
                vm.$emit("selectElement", vm.layer);
            }
        },
        dublicateNode() {
            let vm = this;
            vm.$emit("dublicateElement", vm.layer);
        },
        onDublicateElement(node, children, index) {
            let vm = this;
            // eslint-disable-next-line no-undef
            let newNode = structuredClone(node);
            newNode.itemId = 'item_' + vm.$makeId(20);
            children.splice(index, 0, newNode);
        },
        onDeleteNode() {
            let vm = this;
            vm.$emit("deleteElement", vm.layer);
        },
        onDeleteElement(index) {
            let vm = this;
            eventBus.$emit("onElementSelected", null);
            vm.layer.children.splice(index, 1);
        },
        onPastNode() {
            let vm = this;
            vm.$emit("pastElement", vm.layer);
        },
        onPastElement(node, children, index) {
            let vm = this;
            let newNode = JSON.parse(vm.$localStorage.get("editor_copied_node"));
            newNode.itemId = 'item_' + vm.$makeId(20);
            if (node.itemType == 'container_element') {
                node.children.push(newNode);
            } else {
                children.splice(index, 0, newNode);
            }
            //vm.$localStorage.remove("editor_copied_node");
        }
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.text-fit-warning {
    position: absolute;
    z-index: 9999;
    height: 10px;
    width: 10px;
    background-color: #f44336;
    border-radius: 50%;
    top: 0px;
    left: -10px;
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>